import type { FC } from 'react'
import { Toaster } from 'react-hot-toast'
import '../i18n'

import { MainProvider } from './providers'
import { AppRouter } from '../pages/router'

export const App: FC = () => {
    return (
        <MainProvider>
            <Toaster position="top-center" />
            <AppRouter />
        </MainProvider>
    )
}
